import { Dayjs } from 'dayjs'
import { OAuthCredential, User } from 'firebase/auth'
import { Dispatch, SetStateAction } from 'react'
import ApiClient from '../api/apiClient'

export interface BookedSeat {
  initials: string
  name: string
  userId: string
  businessUnit: string
  bookingUserId?: string
  groupId?: string
  teamId?: string
  isOldOrganiser?: boolean
}

export type GroupMember = {
  userId: string
  name: string
}

export type GroupBooking = {
  id: string
  bookingUserId: string
  businessUnit: string
  dateBooked: Date
  members: GroupMember[]
}

export type LoginContextType = {
  user: User | null
  authenticated: boolean
  setUser: React.Dispatch<React.SetStateAction<User | null>>
  handleAuth: (credential?: OAuthCredential) => void
  isLoading: boolean
}

export type ModalContextType = {
  modalOpen: boolean
  setModalOpen: Dispatch<SetStateAction<boolean>>
  modalContent: JSX.Element
  setModalContent: Dispatch<SetStateAction<JSX.Element>>
  previousContent: JSX.Element
  setPreviousContent: Dispatch<SetStateAction<JSX.Element>>
}

export type MenuContextType = {
  menuOpen: boolean
  setMenuOpen: Dispatch<SetStateAction<boolean>>
}

export interface SeatBooking {
  id: string
  dateBooked: Date
  seats: BookedSeat[]
  lastUpdatedBy?: string
}

export interface UserBooking {
  clubId: string
  date: string
  groupId?: string
  bookingUserId?: string
}

export interface Team {
  id: string
  name: string
  noOfMembers?: number
}
export interface BusinessUnit {
  id: string
  name: string
  deskCapacity: number
  location: string
  teams: Team[]
  region: string
  alternativeOffice?: boolean
}

export interface AndiUserProfile {
  id: string
  userId: string
  businessUnit: string
  team?: string
  name?: string
}

export interface ListOption {
  [key: string]: unknown
}

export type ApiContextType = {
  apiClient: ApiClient
  getUserBooking: () => UserBooking[]
  getSeatBookingOnDate: (date: Date) => SeatBooking | undefined
  getBusinessUnitsBookings: (businessUnitId: string) => SeatBooking[]
  seatBookings: SeatBooking[]
  userProfile: AndiUserProfile | undefined
  businessUnits: BusinessUnit[]
  getANDis: () => AndiUserProfile[]
  getBusinessUnitsANDis: (businessUnitId: string) => AndiUserProfile[]
  getTeams: (selectedBu: string, defaultBu: string) => Team[]
  getMyGroupBookingMembers: (groupId: string | undefined, date: Date) => BookedSeat[] | undefined
}

export interface ReportDateRange {
  id: string
  name: string
  startDate: Dayjs
  endDate: Dayjs
}

export type ReportingContextType = {
  reportSeatBookingsByBU: SeatBooking[]
  reportSeatBookingsByTeam: SeatBooking[]
  reportBusinessUnit: BusinessUnit | undefined
  setReportBusinessUnit: Dispatch<SetStateAction<BusinessUnit | undefined>>
  reportTeam: Team | undefined
  setReportTeam: Dispatch<SetStateAction<Team | undefined>>
  reportDateRange: ReportDateRange | undefined
  setReportDateRange: Dispatch<SetStateAction<ReportDateRange | undefined>>
  firstBookedSeat?: SeatBooking | undefined
}

export type ButtonConfig = {
  text: string
  altText?: string
  isPrimary?: boolean
  isCircle?: boolean
  onClick: (...args: unknown[]) => void | Promise<void>
  maxContent?: boolean
  disabled?: boolean
}

export enum EnvTypes {
  DEV = 'dev',
  STAGING = 'staging',
  PRODUCTION = 'production'
}

export const BookingErrors = (numberOfSeats?: string) => {
  return {
    USER_ALREADY_ADDED: 'Sorry, this user is already added to this booking',
    NO_MORE_SEATS: `There are not enough spaces available to accomodate your booking. Please remove ${numberOfSeats} guests in order to continue`,
    USER_DOES_NOT_EXIST: "Sorry! This user doesn't exist",
    LOCATION_NOT_YET_READY:
      'Unfortunately, AND Space has not landed at this Club yet. Please check again at a later date or select an alternative location from the menu.'
  } as const
}
